import React, { FunctionComponent } from "react";

export const Unknown: FunctionComponent = () => (
    <h1>Stránka nebyla nalezena</h1>
);
